// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main container */
.vegan_toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Filter toggle (if you add this back) */
  /* Main toggler container */
}
@media (min-width: 991px) {
  .vegan_toggle {
    padding: 10px;
  }
}
.vegan_toggle .filter-toggle {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 28px;
  margin-right: 10px;
  cursor: pointer;
}
.vegan_toggle .filter-toggle ion-icon {
  width: 20px;
  height: 20px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle ion-icon {
    width: 30px;
    height: 30px;
  }
}
.vegan_toggle .filter-toggle p {
  font-size: 14px;
  text-transform: capitalize;
  font-weight: bold;
  color: black;
  padding-left: 5px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle p {
    font-size: 18px;
  }
}
.vegan_toggle .toggler {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #567E4A;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 1.5px 7px;
  border-radius: 50px;
  width: 225px;
  height: 50px;
  position: relative;
  /* Individual toggle items */
  /* Visual indicator pin */
}
.vegan_toggle .toggler .toggler_item {
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 19px;
  color: black;
  transition: all 0.4s;
  cursor: pointer;
  width: 33%;
  text-transform: capitalize;
  border: none;
  background: transparent;
  border-radius: 25px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Selected state */
  /* Icon styling */
  /* Text styling */
}
.vegan_toggle .toggler .toggler_item:focus {
  outline: 2px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
  z-index: 11;
}
.vegan_toggle .toggler .toggler_item:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
}
.vegan_toggle .toggler .toggler_item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.vegan_toggle .toggler .toggler_item:active {
  transform: scale(0.95);
}
.vegan_toggle .toggler .toggler_item.selected {
  z-index: 10;
  color: var(--ion-color-secondary);
}
.vegan_toggle .toggler .toggler_item.selected:focus {
  outline-color: var(--ion-color-primary-shade);
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);
}
.vegan_toggle .toggler .toggler_item ion-icon {
  transition: transform 0.3s ease;
}
.vegan_toggle .toggler .toggler_item p {
  margin: 0;
  pointer-events: none;
}
.vegan_toggle .toggler .toggler_pin {
  position: absolute;
  top: -6px;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078);
  transition: all 0.3s ease-out;
  pointer-events: none;
  z-index: 5;
  /* Position states */
  /* Pin image (if you add it back) */
}
.vegan_toggle .toggler .toggler_pin.first {
  left: 10px;
}
.vegan_toggle .toggler .toggler_pin.second {
  left: 36%;
}
.vegan_toggle .toggler .toggler_pin.third {
  left: 65%;
}
.vegan_toggle .toggler .toggler_pin .pin_img {
  height: 40px;
  width: 40px;
}

/* Specific styling for different item types */
.all-item {
  position: relative;
  flex-direction: column;
  /* Enhanced focus state for all item */
}
.all-item ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px !important;
  height: 40px !important;
}
.all-item p {
  position: absolute;
  bottom: 4px;
  color: var(--ion-color-secondary);
  font-size: 15px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}
.all-item:focus ion-icon {
  transform: translate(-50%, -50%) scale(1.1);
}

.image-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  /* Enhanced hover state */
  /* Selected state styling */
}
.image-block ion-icon {
  height: 30px;
  transition: transform 0.3s ease;
}
.image-block .first-img {
  width: 30px !important;
  height: 30px !important;
}
.image-block .second-img {
  width: 25px !important;
  height: 25px !important;
}
.image-block p {
  color: white;
  font-size: 12px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  margin-top: 4px;
}
.image-block:hover ion-icon {
  transform: scale(1.1);
}
.image-block.selected p {
  color: var(--ion-color-secondary);
  font-weight: bold;
}

/* High contrast mode enhancements */
.bsg-high-contrast .vegan_toggle .toggler {
  background: white;
  border: 2px solid black;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item {
  color: black;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item:focus {
  outline: 3px solid #0078d7;
  background-color: #e6f3ff;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item.selected {
  background-color: #e6f3ff;
  border: 2px solid black;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item ion-icon {
  filter: contrast(2);
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_pin {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .vegan_toggle .all-item p {
  color: black !important;
}
.bsg-high-contrast .vegan_toggle .all-item.selected p {
  color: white !important;
  background: black;
  padding: 2px 4px;
  border-radius: 4px;
}
.bsg-high-contrast .vegan_toggle .image-block p {
  color: black !important;
}
.bsg-high-contrast .vegan_toggle .image-block.selected p {
  color: white !important;
  background: black;
  padding: 2px 4px;
  border-radius: 4px;
}

/* Reduced motion support */
.bsg-reduced-motion .toggler_item,
.bsg-reduced-motion .toggler_pin,
.bsg-reduced-motion ion-icon {
  transition: none !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .vegan_toggle .toggler {
    width: 160px;
    height: 45px;
  }
  .vegan_toggle .toggler .toggler_item {
    font-size: 11px;
  }
  .vegan_toggle .toggler .toggler_pin {
    width: 55px;
    height: 55px;
    top: -5px;
  }
  .vegan_toggle .toggler .toggler_pin.second {
    left: 50px;
  }
  .vegan_toggle .toggler .toggler_pin.third {
    left: 100px;
  }
  .vegan_toggle .all-item ion-icon {
    width: 35px !important;
    height: 35px !important;
  }
  .vegan_toggle .all-item p {
    font-size: 13px;
  }
  .vegan_toggle .image-block ion-icon {
    height: 25px;
  }
  .vegan_toggle .image-block .first-img {
    width: 25px !important;
    height: 25px !important;
  }
  .vegan_toggle .image-block .second-img {
    width: 22px !important;
    height: 22px !important;
  }
  .vegan_toggle .image-block p {
    font-size: 11px;
  }
}
/* Animation for smooth interactions */
@keyframes slideIn {
  from {
    transform: translateX(-10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.toggler_item {
  animation: slideIn 0.3s ease-out;
}

/* Loading state (if needed) */
.toggler_item.loading {
  opacity: 0.6;
  cursor: wait;
}
.toggler_item.loading::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
/* Touch improvements for mobile */
@media (hover: none) and (pointer: coarse) {
  .toggler_item {
    min-height: 48px;
    min-width: 48px;
  }
  .toggler_item:hover {
    background-color: transparent;
  }
  .toggler_item:active {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
/* Print styles */
@media print {
  .vegan_toggle .toggler {
    background: white;
    border: 2px solid black;
  }
  .vegan_toggle .toggler .toggler_item {
    color: black;
  }
  .vegan_toggle .toggler .toggler_item.selected {
    background: black;
    color: white;
  }
  .vegan_toggle .toggler .toggler_pin {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-filters/menu-filters.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA,mBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,yCAAA;EAgCA,2BAAA;AArCF;ACnBE;EDeF;IAMI,aAAA;EAEF;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;ACpCE;EDiCE;IAKI,WAAA;IACA,YAAA;EAEN;AACF;AACI;EACE,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AACN;ACjDE;ED2CE;IAQI,eAAA;EAEN;AACF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,4BAAA;EAmEA,yBAAA;AApEJ;AAEI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EAEA,iBAAA;EAQA,0BAAA;EAOA,gBAAA;EAKA,iBAAA;EAKA,mBAAA;EAWA,iBAAA;EAKA,iBAAA;AApCN;AAJM;EACE,wBAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;AAMR;AAFM;EACE,wBAAA;EACA,mBAAA;EACA,8CAAA;AAIR;AAAM;EACE,0CAAA;AAER;AAEM;EACE,sBAAA;AAAR;AAIM;EACE,WAAA;EACA,iCAAA;AAFR;AAIQ;EACE,6CAAA;EACA,6CAAA;AAFV;AAOM;EACE,+BAAA;AALR;AASM;EACE,SAAA;EACA,oBAAA;AAPR;AAYI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,2DAAA;EACA,6BAAA;EACA,oBAAA;EACA,UAAA;EAEA,oBAAA;EAaA,mCAAA;AAvBN;AAWM;EACE,UAAA;AATR;AAYM;EACE,SAAA;AAVR;AAaM;EACE,SAAA;AAXR;AAeM;EACE,YAAA;EACA,WAAA;AAbR;;AAmBA,8CAAA;AACA;EACE,kBAAA;EACA,sBAAA;EAoBA,sCAAA;AAnCF;AAiBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,WAAA;EACA,iCAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AAhBJ;AAqBI;EACE,2CAAA;AAnBN;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAyBA,yBAAA;EAOA,2BAAA;AAnDF;AAqBE;EACE,YAAA;EACA,+BAAA;AAnBJ;AAsBE;EACE,sBAAA;EACA,uBAAA;AApBJ;AAuBE;EACE,sBAAA;EACA,uBAAA;AArBJ;AAwBE;EACE,YAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;AAtBJ;AA2BI;EACE,qBAAA;AAzBN;AA+BI;EACE,iCAAA;EACA,iBAAA;AA7BN;;AAkCA,oCAAA;AAGI;EACE,iBAAA;EACA,uBAAA;AAjCN;AAmCM;EACE,YAAA;AAjCR;AAmCQ;EACE,0BAAA;EACA,yBAAA;AAjCV;AAoCQ;EACE,yBAAA;EACA,uBAAA;AAlCV;AAqCQ;EACE,mBAAA;AAnCV;AAuCM;EACE,iBAAA;EACA,uBAAA;AArCR;AA0CM;EACE,uBAAA;AAxCR;AA2CM;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAzCR;AA8CM;EACE,uBAAA;AA5CR;AA+CM;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA7CR;;AAmDA,2BAAA;AAEE;;;EAGE,2BAAA;AAjDJ;;AAqDA,2BAAA;AACA;EAEI;IACE,YAAA;IACA,YAAA;EAnDJ;EAqDI;IACE,eAAA;EAnDN;EAsDI;IACE,WAAA;IACA,YAAA;IACA,SAAA;EApDN;EAsDM;IACE,UAAA;EApDR;EAuDM;IACE,WAAA;EArDR;EA2DI;IACE,sBAAA;IACA,uBAAA;EAzDN;EA4DI;IACE,eAAA;EA1DN;EA+DI;IACE,YAAA;EA7DN;EAgEI;IACE,sBAAA;IACA,uBAAA;EA9DN;EAiEI;IACE,sBAAA;IACA,uBAAA;EA/DN;EAkEI;IACE,eAAA;EAhEN;AACF;AAqEA,sCAAA;AACA;EACE;IACE,4BAAA;IACA,UAAA;EAnEF;EAqEA;IACE,wBAAA;IACA,UAAA;EAnEF;AACF;AAsEA;EACE,gCAAA;AApEF;;AAuEA,8BAAA;AACA;EACE,YAAA;EACA,YAAA;AApEF;AAsEE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;EACA,oCAAA;EACA,gCAAA;AApEJ;;AAwEA;EACE;IACE,+CAAA;EArEF;AACF;AAwEA,kCAAA;AACA;EACE;IACE,gBAAA;IACA,eAAA;EAtEF;EAwEE;IACE,6BAAA;EAtEJ;EAyEE;IACE,0CAAA;EAvEJ;AACF;AA2EA,iBAAA;AACA;EAEI;IACE,iBAAA;IACA,uBAAA;EA1EJ;EA4EI;IACE,YAAA;EA1EN;EA4EM;IACE,iBAAA;IACA,YAAA;EA1ER;EA8EI;IACE,aAAA;EA5EN;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Main container */\n.vegan_toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  @include desktop {\n    padding: 10px;\n  }\n\n  /* Filter toggle (if you add this back) */\n  .filter-toggle {\n    display: flex;\n    align-items: center;\n    padding: 5px 10px;\n    border-radius: 28px;\n    margin-right: 10px;\n    cursor: pointer;\n    \n    ion-icon {\n      width: 20px;\n      height: 20px;\n      \n      @include desktop {\n        width: 30px;\n        height: 30px;\n      }\n    }\n    \n    p {\n      font-size: 14px;\n      text-transform: capitalize;\n      font-weight: bold;\n      color: black;\n      padding-left: 5px;\n      \n      @include desktop {\n        font-size: 18px;\n      }\n    }\n  }\n  \n  /* Main toggler container */\n  .toggler {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #567E4A;\n    box-shadow: 0px 10px 20px 0px #00000033 inset;\n    padding: 1.5px 7px;\n    border-radius: 50px;\n    width: 225px;\n    height: 50px;\n    position: relative;\n    \n    /* Individual toggle items */\n    .toggler_item {\n      padding: 0;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-family: AppFontBold;\n      font-size: 12px;\n      line-height: 19px;\n      color: black;\n      transition: all 0.4s;\n      cursor: pointer;\n      width: 33%;\n      text-transform: capitalize;\n      border: none;\n      background: transparent;\n      border-radius: 25px;\n      \n      /* Focus styles */\n      &:focus {\n        outline: 2px solid white;\n        outline-offset: 2px;\n        box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);\n        z-index: 11;\n      }\n      \n      /* Keyboard focus styles */\n      &:focus-visible {\n        outline: 2px solid white;\n        outline-offset: 2px;\n        box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);\n      }\n      \n      /* Hover state */\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n      \n      /* Active state */\n      &:active {\n        transform: scale(0.95);\n      }\n      \n      /* Selected state */\n      &.selected {\n        z-index: 10;\n        color: var(--ion-color-secondary);\n        \n        &:focus {\n          outline-color: var(--ion-color-primary-shade);\n          box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);\n        }\n      }\n      \n      /* Icon styling */\n      ion-icon {\n        transition: transform 0.3s ease;\n      }\n      \n      /* Text styling */\n      p {\n        margin: 0;\n        pointer-events: none;\n      }\n    }\n    \n    /* Visual indicator pin */\n    .toggler_pin {\n      position: absolute;\n      top: -6px;\n      width: 65px;\n      height: 65px;\n      border-radius: 50%;\n      background: var(--ion-color-primary);\n      box-shadow: 0px 4px 15px 0px #4F614F26;\n      transition: all 0.3s ease-out;\n      pointer-events: none;\n      z-index: 5;\n      \n      /* Position states */\n      &.first {\n        left: 10px;\n      }\n      \n      &.second {\n        left: 36%;\n      }\n      \n      &.third {\n        left: 65%;\n      }\n      \n      /* Pin image (if you add it back) */\n      .pin_img {\n        height: 40px;\n        width: 40px;\n      }\n    }\n  }\n}\n\n/* Specific styling for different item types */\n.all-item {\n  position: relative;\n  flex-direction: column;\n  \n  ion-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 40px !important;\n    height: 40px !important;\n  }\n  \n  p {\n    position: absolute;\n    bottom: 4px;\n    color: var(--ion-color-secondary);\n    font-size: 15px;\n    font-family: AppFontBold, sans-serif;\n    text-transform: uppercase;\n  }\n  \n  /* Enhanced focus state for all item */\n  &:focus {\n    ion-icon {\n      transform: translate(-50%, -50%) scale(1.1);\n    }\n  }\n}\n\n.image-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-top: 5px;\n  \n  ion-icon {\n    height: 30px;\n    transition: transform 0.3s ease;\n  }\n  \n  .first-img {\n    width: 30px !important;\n    height: 30px !important;\n  }\n  \n  .second-img {\n    width: 25px !important;\n    height: 25px !important;\n  }\n  \n  p {\n    color: white;\n    font-size: 12px;\n    font-family: AppFontBold, sans-serif;\n    text-transform: uppercase;\n    margin-top: 4px;\n  }\n  \n  /* Enhanced hover state */\n  &:hover {\n    ion-icon {\n      transform: scale(1.1);\n    }\n  }\n  \n  /* Selected state styling */\n  &.selected {\n    p {\n      color: var(--ion-color-secondary);\n      font-weight: bold;\n    }\n  }\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .vegan_toggle {\n    .toggler {\n      background: white;\n      border: 2px solid black;\n      \n      .toggler_item {\n        color: black;\n        \n        &:focus {\n          outline: 3px solid #0078d7;\n          background-color: #e6f3ff;\n        }\n        \n        &.selected {\n          background-color: #e6f3ff;\n          border: 2px solid black;\n        }\n        \n        ion-icon {\n          filter: contrast(2);\n        }\n      }\n      \n      .toggler_pin {\n        background: black;\n        border: 2px solid white;\n      }\n    }\n    \n    .all-item {\n      p {\n        color: black !important;\n      }\n      \n      &.selected p {\n        color: white !important;\n        background: black;\n        padding: 2px 4px;\n        border-radius: 4px;\n      }\n    }\n    \n    .image-block {\n      p {\n        color: black !important;\n      }\n      \n      &.selected p {\n        color: white !important;\n        background: black;\n        padding: 2px 4px;\n        border-radius: 4px;\n      }\n    }\n  }\n}\n\n/* Reduced motion support */\n.bsg-reduced-motion {\n  .toggler_item,\n  .toggler_pin,\n  ion-icon {\n    transition: none !important;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .vegan_toggle {\n    .toggler {\n      width: 160px;\n      height: 45px;\n      \n      .toggler_item {\n        font-size: 11px;\n      }\n      \n      .toggler_pin {\n        width: 55px;\n        height: 55px;\n        top: -5px;\n        \n        &.second {\n          left: 50px;\n        }\n        \n        &.third {\n          left: 100px;\n        }\n      }\n    }\n    \n    .all-item {\n      ion-icon {\n        width: 35px !important;\n        height: 35px !important;\n      }\n      \n      p {\n        font-size: 13px;\n      }\n    }\n    \n    .image-block {\n      ion-icon {\n        height: 25px;\n      }\n      \n      .first-img {\n        width: 25px !important;\n        height: 25px !important;\n      }\n      \n      .second-img {\n        width: 22px !important;\n        height: 22px !important;\n      }\n      \n      p {\n        font-size: 11px;\n      }\n    }\n  }\n}\n\n/* Animation for smooth interactions */\n@keyframes slideIn {\n  from {\n    transform: translateX(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.toggler_item {\n  animation: slideIn 0.3s ease-out;\n}\n\n/* Loading state (if needed) */\n.toggler_item.loading {\n  opacity: 0.6;\n  cursor: wait;\n  \n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 16px;\n    height: 16px;\n    border: 2px solid currentColor;\n    border-radius: 50%;\n    border-top-color: transparent;\n    animation: spin 0.8s linear infinite;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n/* Touch improvements for mobile */\n@media (hover: none) and (pointer: coarse) {\n  .toggler_item {\n    min-height: 48px;\n    min-width: 48px;\n    \n    &:hover {\n      background-color: transparent;\n    }\n    \n    &:active {\n      background-color: rgba(255, 255, 255, 0.2);\n    }\n  }\n}\n\n/* Print styles */\n@media print {\n  .vegan_toggle {\n    .toggler {\n      background: white;\n      border: 2px solid black;\n      \n      .toggler_item {\n        color: black;\n        \n        &.selected {\n          background: black;\n          color: white;\n        }\n      }\n      \n      .toggler_pin {\n        display: none;\n      }\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
